
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cursos",
      function () {
        return require("private-next-pages/cursos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cursos"])
      });
    }
  